import { StyledAlert, PaddedSurface as Surface } from "App/global-style";
import {
  BRAND_MODEL_MAX_CHARACTER_LENGTH,
  VEHICLE_TYPE,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { AlertType } from "Components/Form/Alert";
import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { RecentDamages } from "Components/Form/RecentDamages";
import { Select } from "Components/Form/Select";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { getValidRegistrationYearOptions } from "../../vehicleUtils";
import { ElectricScooterTexts } from "../interface";
import { ElectricScooterProductIntroFormValues } from "./interface";

interface Props {
  formProps: FormikProps<ElectricScooterProductIntroFormValues>;
  texts: ElectricScooterTexts["formText"]["checkPrice"];
  lang: TextLanguage;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { texts, lang, formProps } = props;

  const modelYearOptions = getValidRegistrationYearOptions(
    VEHICLE_TYPE.ELECTRIC_SCOOTER,
  );
  // Temporary solution for placeholder as necessary logic
  // inside of Select requires a major bumb to alpha of 3.0.0
  const placeholder = {
    value: "",
    label: texts.modelYear?.placeholder?.[lang] ?? "",
  };

  return (
    <>
      <Surface>
        <RadioButtonTrueFalse
          id="topSpeed"
          name="topSpeed"
          label={texts.topSpeed?.label[lang]}
          options={getYesOrNoOptions("yes", "no")}
          error={getError("topSpeed", formProps)}
          direction="vertical"
        />
        {formProps.values.topSpeed === BooleanFormType.FALSE && (
          <StyledAlert
            type="error"
            alertId="topSpeed"
            alertType={AlertType.STOPPER_ALERT}
            title={texts.topSpeed.error.isFalseTitle[lang]}
            description={texts.topSpeed.error.isFalseInfo[lang]}
            fluid
          />
        )}
        <Select
          id="modelYear"
          name="modelYear"
          label={texts.modelYear?.label[lang]}
          options={[placeholder, ...modelYearOptions]}
          hint={texts.modelYear?.hint?.[lang]}
          error={getError("modelYear", formProps)}
          large
        />
        <Input
          id="brand"
          name="brand"
          label={texts.brand?.label[lang]}
          placeholder={texts.brand?.placeholder?.[lang]}
          error={getError("brand", formProps)}
          large
          inputProps={{ maxLength: BRAND_MODEL_MAX_CHARACTER_LENGTH }}
          inputMode={InputMode.TEXT}
        />
        <Input
          id="model"
          name="model"
          label={texts.model?.label[lang]}
          error={getError("model", formProps)}
          large
          inputProps={{ maxLength: BRAND_MODEL_MAX_CHARACTER_LENGTH }}
          inputMode={InputMode.TEXT}
        />
      </Surface>
      <Surface>
        <RecentDamages
          formProps={formProps}
          productName={ProductBackendName.ELECTRIC_SCOOTER}
        />
      </Surface>
    </>
  );
};
